export const traits_avatar = [
    {
        factor: 1,
        traits: [
            {
                name: "The Protector",
                description: "The Protectors are resolute in nature. They value stability, and focus on tangible outcomes and traditional work settings.",
                image: "",
            },
            {
                name: "The Ambassador",
                description: "The Ambassadors can find balance between adaptability and stability, seamlessly integrating flexible approaches with traditional methods to achieve effective results.",
                image: "",
            },
            {
                name: "The Wanderer",
                description: "The Wanderers are able to navigate changing circumstances, take advantage of flexible schedules, and thrive in informal work environments.",
                image: "",
            },
        ]
    },
    {
        factor: 2,
        traits: [
            {
                name: "Bohemian",
                description: "Bohemians have a calm and open-minded attitude while seeking personal growth and collaborating in a nurturing work setting.",
                image: "",
            },
            {
                name: "Mellow Seeker", 
                description: "Mellow Seekers smoothly blend adaptability and calm collaboration, finding a harmonious balance between adjusting to changing situations and maintaining a serene and cooperative work ",
                image: "",
            },
            {
                name: "Nomad",
                description: "Nomads flexibly navigate changing landscapes with resilience and versatility.",
                image: "",
            },
        ]
    },
    {
        factor: 3,
        traits: [
            {
                name: "The Creator",
                description: "The Creators prefer self-reliance, taking action under stress, being assertive in sharing ideas, and being driven by personal motivations rather than external recognition. ",
                image: "",
            },
            {
                name: "The Sage",
                description: "The Sages strike a balance between valuing personal autonomy and contributing positively to group dynamics, promoting collaboration and unity while respecting individuality.",
                image: "",
            },
            {
                name: "The Collaborator",
                description: "The Collaborators create cohesion and synergy within diverse groups. ",
                image: "",
            },
        ]
    },
    {
        factor: 4,
        traits: [
            {
                name: "Phoenix",
                description: "Phoenixes have forward-thinking mindset, enthusiasm for new ideas, and has the ability to navigate situations with flexibility and a fresh perspective.",
                image: "",
            },
            {
                name: "The Conductor",
                description: "The Conductors are skilled in maintaining a steady foundation while embracing new ideas and approaches when necessary.",
                image: "",
            },
            {
                name: "The Guardian",
                description: "The Guardians are dependable, value predictability, security, and prefer maintaining a steady course in both their work environment and routines.",
                image: "",
            },
        ]
    },
    {
        factor: 5,
        traits: [
            {
                name: "The Mentor",
                description: "The Mentors have a balanced approach to work, value personal growth and helping others, rather than being solely driven by high-level positions, ambition, and competitiveness.",
                image: "",
            },
            {
                name: "Psychic Reader",
                description: "Psychic Readers have ambitious dreams and goals while also prioritizing personal growth, well-being, and mentoring others.",
                image: "",
            },
            {
                name: "Trailblazer",
                description: "Trailblazers paints grand visions and strives to turn them into reality through determination and foresight.",
                image: "",
            },
        ]
    },
]